import * as React from 'react'
import createSvgIcon from './createSvgIcon'
import styled from 'styled-components/macro'

const Tag = createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_355_5389)">
      <path
        d="M7.25195 7.5C7.25195 7.76522 7.35731 8.01957 7.54485 8.20711C7.73238 8.39464 7.98674 8.5 8.25195 8.5C8.51717 8.5 8.77152 8.39464 8.95906 8.20711C9.1466 8.01957 9.25195 7.76522 9.25195 7.5C9.25195 7.23478 9.1466 6.98043 8.95906 6.79289C8.77152 6.60536 8.51717 6.5 8.25195 6.5C7.98674 6.5 7.73238 6.60536 7.54485 6.79289C7.35731 6.98043 7.25195 7.23478 7.25195 7.5Z"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75195 6V11.172C3.75207 11.7024 3.96285 12.211 4.33795 12.586L12.048 20.296C12.4999 20.7479 13.1128 21.0017 13.752 21.0017C14.3911 21.0017 15.004 20.7479 15.456 20.296L21.048 14.704C21.4998 14.252 21.7537 13.6391 21.7537 13C21.7537 12.3609 21.4998 11.748 21.048 11.296L13.338 3.586C12.963 3.2109 12.4543 3.00011 11.924 3H6.75195C5.9563 3 5.19324 3.31607 4.63063 3.87868C4.06802 4.44129 3.75195 5.20435 3.75195 6Z"
        fill="none"
        stroke="var(--text-heading)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_355_5389">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.751953)"
        />
      </clipPath>
    </defs>
  </React.Fragment>,
  'Notes'
)

export default styled(Tag)`
  g {
    transform: translate(3px, 3px);
  }
`
